import { render, staticRenderFns } from "./moreHDPF.vue?vue&type=template&id=502c47c2&lang=pug&"
import script from "./moreHDPF.vue?vue&type=script&lang=js&"
export * from "./moreHDPF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports